import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClickJump = (item: string) => {
    if (item === "Home") {
      navigate("/");
    } else {
      navigate(`/${item.toLocaleLowerCase()}`);
    }
  };

  return (
    <>
      <div className="w-full flex justify-center bg-[#181818] px-8 py-12">
        <div className="w-full flex flex-col items-center 2xl:px-32 lg:px-16 sm:px-6 text-white/90">
          <div
            className={`w-full ${
              windowWidth > 1150
                ? "flex justify-between"
                : "flex flex-col gap-y-4"
            }`}
          >
            <div
              className={`flex flex-col ${
                windowWidth > 1150 ? "w-[25%]" : "w-full"
              }`}
            >
              <div className="mb-8 border-b-[1px] border-[#f7f2eb]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-wider ${
                    windowWidth > 1150 ? "text-lg" : "text-base"
                  }`}
                >
                  ABOUT ME
                </h5>
                <span className="block w-16 h-[3px] bg-[#f7f2eb]"></span>
              </div>
              <p className="md:text-lg text-base">
                {process.env.REACT_APP_DESCRIPTION}
              </p>
            </div>
            <div
              className={`flex flex-col ${
                windowWidth > 1150 ? "w-[15%]" : "w-full"
              }`}
            >
              <div className="mb-8 border-b-[1px] border-[#f7f2eb]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-wider ${
                    windowWidth > 1150 ? "text-lg" : "text-base"
                  }`}
                >
                  QUICK LINK
                </h5>
                <span className="block w-16 h-[3px] bg-[#f7f2eb]"></span>
              </div>
              <ul className="flex flex-col md:text-lg text-base font-mediu">
                {["Home", "Travel", "Guides", "Food", "Hotels"].map(
                  (item, index) => (
                    <li
                      key={index}
                      className={`flex border-b-[1px] border-dotted border-[#f7f2eb] py-2 cursor-pointer last-of-type:border-b-0
                           ${
                             location.pathname === item.toLocaleLowerCase()
                               ? "font-bold"
                               : "hover:text-[#c9b077]"
                           }`}
                      onClick={() => handleClickJump(item)}
                    >
                      <span>{item}</span>
                    </li>
                  ),
                )}
              </ul>
            </div>
            <div
              className={`flex flex-col ${
                windowWidth > 1150 ? "w-[25%]" : "w-full"
              }`}
            >
              <div className="mb-8  border-b-[1px] border-[#f7f2eb]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-wider ${
                    windowWidth > 1150 ? "text-lg " : "text-base"
                  }`}
                >
                  TAGCLOUD
                </h5>
                <span className="block w-16 h-[3px] bg-[#f7f2eb]"></span>
              </div>
              <ul className="flex flex-wrap md:text-lg text-sm font-mediu">
                {[
                  "Cultural Stays",
                  "Living guide",
                  "Festival foods",
                  "Seasonal view",
                  "Tropical getaways",
                  // "Tea mastery",
                  // "Puppet theatre",
                ].map((item, index) => (
                  <li
                    key={index}
                    className="flex border-[1px] border-[#f7f2eb] px-5 py-2 bg-black rounded-full mr-2 mb-3"
                  >
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div
              className={`flex flex-col   ${
                windowWidth > 1150 ? "w-[30%]" : "w-full"
              }`}
            >
              <div className="mb-8  border-b-[1px] border-[#f7f2eb]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-wider ${
                    windowWidth > 1150 ? "text-lg" : "text-base"
                  }`}
                >
                  NEWSLETTER
                </h5>
                <span className="block w-16 h-[3px] bg-[#f7f2eb]"></span>
              </div>
              <p className="md:text-lg text-base line-clamp-3">
                Subscribe to our newsletter and get our newest updates right on
                your inbox.
              </p>
              <form className="mt-8 flex flex-col">
                <div className="flex items-center mb-5 md:text-lg text-base">
                  <input
                    className="w-[62%] py-3 px-4 text-[#181818] placeholder:text-[#909090] border-[1px] border-r-0 border-[#dddddd] rounded-full rounded-r-none focus:outline-none"
                    type="text"
                    placeholder="Enter your email"
                  />
                  <button
                    type="button"
                    className="w-[38%] py-3 border-[1px] border-l-0 border-[#dddddd] rounded-full rounded-l-none bg-[#6f6f6f] hover:bg-[#3c3c3c]  md:text-lg text-base font-bold"
                  >
                    Subscribe
                  </button>
                </div>
                <label>
                  <input type="checkbox" />
                  <span className="md:text-lg text-base ml-2">
                    I agree to the{" "}
                    <b className="text-[#f7f2eb] font-medium">
                      terms & conditions
                    </b>
                  </span>
                </label>
              </form>
            </div>
          </div>
          <div
            className={`w-full flex pt-8 mt-8 border-t-[1px] border-[#f7f2eb] md:text-lg text-sm ${
              windowWidth > 1150
                ? " justify-between space-x-2"
                : " flex-col space-y-2"
            }`}
          >
            <span>
              ©2025 clickandchill. Everything you need to know about Travel.
            </span>
            <span>
              All Rights Reserved. |{" "}
              <b
                className=" cursor-pointer underline hover:text-[#c9b077]"
                onClick={() => (window.location.href = "/privacy")}
              >
                Privacy Policy
              </b>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
